import AddressFilter from "components/filters/Filters/AddressFilter";
import ArtistFilter from "components/filters/Filters/ArtistFilter";
import BookkeepingFilter from "components/filters/Filters/BookkeepingFilter";
import ContactFilter from "components/filters/Filters/ContactFilter";
import CostCenterFilter from "components/filters/Filters/CostCenterFilter";
import KeywordFilter from "components/filters/Filters/KeywordFilter";
import OwnersFilter from "components/filters/Filters/OwnersFilter";
import PeriodFilter from "components/filters/Filters/PeriodFilter";
import PromoterFilter from "components/filters/Filters/PromoterFilter";
import PublicationFilter from "components/filters/Filters/PublicationFilter";
import { ShowSortFilter } from "components/filters/Filters/SortFilter";
import StatusFilter from "components/filters/Filters/StatusFilter";
import TagFilter from "components/filters/Filters/TagFilter";
import VenueFilter from "components/filters/Filters/VenueFilter";
import React, { useContext, useEffect } from "react";
import HotelFilter from "components/filters/Filters/HotelFilter";
import ProductionFilter from "components/filters/Filters/ProductionFilter";
import { FilterContext } from "components/filters/FilterContext";
import OnlyMySelectionFilter from "components/filters/Filters/OnlyMySelectionFilter";
import { PlanningContext } from "PlanningContext/PlanningContext";

interface FiltersProps {
  initialTags: server.dto.TagSmall[]
  initialStatuses: server.dto.StatusSmall[]
  initialBookkeepings: server.dto.BookkeepingSmall[]
}

const Filters = (props: FiltersProps) => {
  const filterContext = useContext(FilterContext);
  const planningContext = useContext(PlanningContext);

  const artist = filterContext.getValue("artist");
  const period = filterContext.getValue("period");

  useEffect(() => {
    planningContext.setOpts({
      artist: artist.selectedArtists.length > 0 ? artist.selectedArtists[0] : undefined,
      date: period.period === "perDay" ? period.selectionStart : null,
    });
  }, [artist, period]);

  return <>
    <KeywordFilter placeholder={RESX.GeneralLabels.Search} />
    <ArtistFilter />
    <VenueFilter />
    <PromoterFilter />
    <HotelFilter />
    <ContactFilter title={RESX.Planning.Attendee} />
    <ProductionFilter />
    <TagFilter initialTags={props.initialTags} mainArea="show" />
    <AddressFilter />
    {props.initialStatuses.length > 1 && (
      <StatusFilter initialStatuses={props.initialStatuses} />
    )}
    <BookkeepingFilter />
    <CostCenterFilter />
    <PublicationFilter />
    <OwnersFilter />
    <PeriodFilter />
    <ShowSortFilter />
    <OnlyMySelectionFilter />
  </>;
};

export default Filters;